import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2447">
      <div className="dark" data-id="element-2448">
        <Hero data-id="element-2449" />
      </div>
      <WhyUs data-id="element-2450" />
      <ByTheNumbers data-id="element-2451" />
      <Services data-id="element-2452" />
      <HowItWorks data-id="element-2453" />
      <FAQ data-id="element-2454" />
      <Reviews data-id="element-2455" />
      <CtaBanner data-id="element-2456" />
    </main>;
}